<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

            </div>
        </div>

        <div class="row">
            <div class="col-md-3 custom-sidebar py-5">
                <h4 class="side-navbar-title mb-4">Regulatory Filing</h4>
                <div class="panel-group side-navbar">
                    <a href="#" target="_self" class="nav-link" :class="{ active : tabIndexRFParent == 0 }" @click.stop="open_item_selected(0)">Income Tax Act 2023</a>

                    <a href="#" target="_self" class="nav-link" :class="{ active : tabIndexRFParent == 1 }" @click.stop="open_item_selected(1)">Income Tax Ordinance 1984</a>
                </div>
            </div>
            <div class="col-md-9 pr-0">
                <div class="regulatory-filing-tab payroll-reporting-tab col-md-12" id="nav-tabContent-intro">
                    <b-tabs content-class="reports-tab-wrapper" nav-wrapper-class="mb-5 reports-tab-nav-wrapper d-none" v-model="tabIndexRFParent">
                        <b-tab lazy> <!-- Mustafijur: 13-05-2026 -->
                            <template active v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only'  &&  $atl_company_package_title != 'Provident And Gratuity Fund Only'"  v-slot:title>Income Tax Act 2023</template>
                            <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Income Tax Act 2023</template>
                            <template v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only'  &&  $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Regulatory Filing<span>
                                    <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Regulatory Filing / Income Tax Act 2023</span>
                                </h4>
                                <p class="text-secondary pt-4">Use our regulatory compliance engine to download and file all regulatory payroll reports required under Bangladesh tax regulations. You may also upload receipts for compliance tracking. Once a pay run is approved, the relevant regulatory filing is automatically updated/generated for you to download and file.</p>
                                <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav" v-model="tabIndexRF">
                                    <b-tab lazy @click="handleChange(0)"> <!-- Mustafijur: 13-05-2026 -->
                                        <template #title>
                                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                <img v-bind:src="$api_url+'/images/schedule-F.png'" class="light-mode-icon"/>
                                                <h5>Schedule F / তফসিল চ</h5>
                                                <p><span class="text-secondary d-block font-semi-bold">Detailed Statement of Salary Payment</span>Get your annual salary statement that is required to be filed by 25th October of each year under Income Tax SRO No. 161-Law/Income Tax-36/2024 dated 29 May 2024 of the Income Tax Act 2023.</p>
                                                <b-button class="btn btn-primary">View Report</b-button>
                                            </div>
                                        </template>
                                        <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                        <div class="row mt-4 no-margin">
                                            <div class="ibox col-md-12">
                                                <div class="ibox-title dashboard_title px-0">
                                                    <h4 class="font-regular with-blue-text">Current Selected: <span>Schedule F / তফসিল চ</span></h4>
                                                </div>
                                                <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                                                    <div class="d-inline-block trz_fields trz-custom-dropdown mb-1" >
                                                        <b-dropdown id="dropdown-fields"  text="Select Additional Fields" ref="dropdown" class="mb-1 position-relative">
                                                            <b-dropdown-form>
                                                                <b-form-group @submit.stop.prevent>
                                                                    <div class="form-group">
                                                                        <b-form-checkbox-group
                                                                            v-model="column_selected"
                                                                            :options="column_options"
                                                                            switches

                                                                        />
                                                                    </div>
                                                                    <button type="button" @click="setcolumn()" class="btn btn-primary d-none">Save</button>
                                                                </b-form-group>
                                                            </b-dropdown-form>
                                                        </b-dropdown>
                                                    </div>
                                                    {{clickSelect}}
                                                    <div class="d-inline-block report-selected-columns" v-if="column_selected_view.length > 0"> <span class="font-semi-bold text-secondary py-1 px-2 bg-white rounded" v-for="column in column_selected_view">{{ stringView(column) }}</span></div>
                                                </div>
                                            </div>
                                            <div class="ibox col-md-12">
                                                <div class="ibox-content px-0 pt-3">
                                                    <table class="table 108_return">
                                                        <thead>
                                                            <tr class="table-head">
                                                            <th scope="col">Type of Return</th>
                                                            <th scope="col">Fiscal Year</th>
                                                            <th scope="col">Download (English)</th>
                                                            <th scope="col">Download (Bangla)</th>
                                                            <th scope="col">Upload Receipt</th>
                                                            <th scope="col">Download Receipt</th>
                                                            <th scope="col">Submission Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr style="display: none;"></tr>
                                                            <tr class="table-row hover-bg" v-for="(data, n) in received_report_info" :key="n">
                                                                <td>Schedule F / তফসিল চ</td>
                                                                <td>{{data.fiscal_year}}</td>
                                                                <td><a @click="getReport(data.fiscal_year, '', 'new', 'en')" class="cursor-pointer" v-if="$acl['regulatory/filing/download'] == 2"><img v-bind:src="$api_url+'/images/excel-icon.png'" class="mr-2" width="20px"/>Download</a></td>
                                                                <td><a @click="getReport(data.fiscal_year, '', 'new', 'bn')" class="cursor-pointer" v-if="$acl['regulatory/filing/download'] == 2"><img v-bind:src="$api_url+'/images/excel-icon.png'" class="mr-2" width="20px"/>Download</a></td>
                                                                <td><a href="#" @click="showUpload(data.fiscal_year , '')" v-if="$acl['regulatory/filing/upload'] == 2"><b-icon icon="upload" class="mr-2"></b-icon>Upload</a></td>
                                                                <td><a v-if="data.received_copy_108 == 'yes' && $acl['regulatory/filing/download'] == 2" :href="$api_url+'/payroll_report_return108?received_report=received_download&year='+data.fiscal_year+'&dataflg=1'"><b-icon icon="download" class="mr-2"></b-icon>Download</a><a v-else>N/A</a></td>
                                                                <td>{{data.file_date_108 || compliance_placeholder}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        </template>
                                        <template v-else>
                                            <lock-template ></lock-template>
                                        </template>
                                    </b-tab>
                                    <b-tab lazy @click="handleChange(1)"> <!-- Mustafijur: 13-05-2026 -->
                                        <template #title>
                                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                <img v-bind:src="$api_url+'/images/schedule-G.png'" class="light-mode-icon"/>
                                                <h5>Schedule G / তফসিল ছ</h5>
                                                <p><span class="text-secondary d-block font-semi-bold">Statement of Employee Tax Return</span>Get your annual tax return filing statement that is required to be filed by 25th April of each year under Income Tax SRO No. 161-Law/Income Tax-36/2024 dated 29 May 2024 of the Income Tax Act 2023.</p>
                                                <b-button class="btn btn-primary">View Report</b-button>
                                            </div>
                                        </template>
                                        <div>
                                        <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                            <div class="row mt-4 no-margin">
                                                <div class="ibox col-md-12">
                                                    <div class="ibox-title dashboard_title px-0">
                                                        <h4 class="font-regular with-blue-text">Current Selected: <span>Schedule G / তফসিল ছ</span></h4>
                                                    </div>
                                                    <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                                                        <div class="d-inline-block trz_fields trz-custom-dropdown mb-1" >
                                                            <b-dropdown id="dropdown-fields"  text="Select Additional Fields" ref="dropdown" class="mb-1 position-relative">
                                                                <b-dropdown-form>
                                                                    <b-form-group @submit.stop.prevent>
                                                                        <div class="form-group">
                                                                            <b-form-checkbox-group
                                                                                v-model="column_selected"
                                                                                :options="column_options"
                                                                                switches

                                                                            />
                                                                        </div>
                                                                        <button type="button" @click="setcolumn()" class="btn btn-primary d-none">Save</button>
                                                                    </b-form-group>
                                                                </b-dropdown-form>
                                                            </b-dropdown>
                                                        </div>
                                                        {{clickSelect}}
                                                        <!-- alpha fix- removed class ml-2  -->
                                                        <div class="d-inline-block report-selected-columns" v-if="column_selected_view.length > 0"> <span class="font-semi-bold text-secondary py-1 px-2 bg-white rounded" v-for="column in column_selected_view">{{ stringView(column) }}</span></div>
                                                    </div>
                                                </div>
                                                <div class="ibox col-md-12">
                                                    <div class="ibox-content px-0 pt-3">
                                                        <table class="table 108A_return ">
                                                            <thead>
                                                                <tr class="table-head">
                                                                <th scope="col">Type of Return</th>
                                                                <th scope="col">Fiscal Year</th>
                                                                <th scope="col">Download (English)</th>
                                                                <th scope="col">Download (Bangla)</th>
                                                                <th scope="col">Upload Receipt</th>
                                                                <th scope="col">Download Receipt</th>
                                                                <th scope="col">Submission Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr style="display: none;"></tr>
                                                                <tr class="table-row hover-bg" v-for="(data, n) in received_report_info" :key="n">
                                                                    <td>Schedule G / তফসিল ছ</td>
                                                                    <td>{{data.fiscal_year}}</td>
                                                                    <td><a @click="getReport(data.fiscal_year, 'A', 'new', 'en')" class="cursor-pointer" v-if="$acl['regulatory/filing/download'] == 2"><img v-bind:src="$api_url+'/images/excel-icon.png'" class="mr-2" width="20px"/>Download</a></td>
                                                                    <td><a @click="getReport(data.fiscal_year, 'A', 'new', 'bn')" class="cursor-pointer" v-if="$acl['regulatory/filing/download'] == 2"><img v-bind:src="$api_url+'/images/excel-icon.png'" class="mr-2" width="20px"/>Download</a></td>
                                                                    <td><a href="#" @click="showUpload(data.fiscal_year , 'A')" v-if="$acl['regulatory/filing/upload'] == 2"><b-icon icon="upload" class="mr-2"></b-icon>Upload</a></td>
                                                                    <td><a v-if="data.received_copy_108a == 'yes' && $acl['regulatory/filing/download'] == 2" :href="$api_url+'/payroll_report_return108a?received_report=received_download&year='+data.fiscal_year+'&dataflg=1'"><b-icon icon="download" class="mr-2"></b-icon>Download</a><a v-else>N/A</a></td>
                                                                    <td>{{data.file_date_108a || compliance_placeholder}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <lock-template ></lock-template>
                                        </template>
                                        </div>
                                    </b-tab>
                                    <b-tab lazy @click="handleChange(2)"> <!-- Mustafijur: 13-05-2026 -->
                                        <template #title>
                                             <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                <img v-bind:src="$api_url+'/images/schedule-C.png'" class="light-mode-icon"/>
                                                <h5>Schedule C / তফসিল গ</h5>
                                                <p><span class="text-secondary d-block font-semi-bold">Tax Deduction from Salary</span>Get your monthly salary statement that is required to be filed by the 25th of the following month under Income Tax SRO No. 161-Law/Income Tax-36/2024 dated 29 May 2024 of the Income Tax Act 2023.</p>
                                                <b-button class="btn btn-primary">View Report</b-button>
                                            </div>
                                        </template>
                                        <div>
                                            <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                                <statement-of-deduct-data  :key="tabKey" :new_law="'yes'"></statement-of-deduct-data>
                                            </template>
                                            <template v-else>
                                                <lock-template ></lock-template>
                                            </template>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </template>
                        </b-tab>
                        <b-tab lazy> <!-- Mustafijur: 13-05-2026 -->
                            <template active v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only'  &&  $atl_company_package_title != 'Provident And Gratuity Fund Only'"  v-slot:title>Income Tax Ordinance 1984</template>
                            <template v-else active v-slot:title> <b-icon icon="lock-fill" aria-hidden="true" class='lock-icon-trz-tab'></b-icon>Income Tax Ordinance 1984</template>
                            <template v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only'  &&  $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Regulatory Filing<span>
                                    <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Regulatory Filing / Income Tax Ordinance 1984</span>
                                </h4>
                                <p class="text-secondary pt-4">Use our regulatory compliance engine to download and file all regulatory payroll reports required under Bangladesh tax regulations. You may also upload receipts for compliance tracking. Once a pay run is approved, the relevant regulatory filing is automatically updated/generated for you to download and file.</p>
                                <b-tabs content-class="mt-3" nav-wrapper-class="mt-4 reports-tab-nav" v-model="tabIndexRF">
                                    <b-tab lazy @click="handleChange(0)"> <!-- Mustafijur: 13-05-2026 -->
                                        <template #title>
                                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                <img v-bind:src="$api_url+'/images/return-108-new.png'" class="light-mode-icon"/>
                                                <h5>Return u/s 108</h5>
                                                <p>Get your annual salary statement that is required to be filed by 31 August of each year under Section 108 of the Income Tax Ordinance 1984.</p>
                                                <b-button class="btn btn-primary">View Report</b-button>
                                            </div>
                                        </template>
                                        <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                            <div class="row mt-4 no-margin">
                                                <div class="ibox col-md-12">
                                                    <div class="ibox-title dashboard_title px-0">
                                                        <h4 class="font-regular with-blue-text">Current Selected: <span>Return u/s 108</span></h4>
                                                    </div>
                                                    <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                                                        <div class="d-inline-block trz_fields trz-custom-dropdown" >
                                                            <b-dropdown id="dropdown-fields"  text="Select Additional Fields" ref="dropdown" class="mb-1 position-relative">
                                                                <b-dropdown-form>
                                                                    <b-form-group @submit.stop.prevent>
                                                                        <div class="form-group">
                                                                            <b-form-checkbox-group
                                                                                v-model="column_selected"
                                                                                :options="column_options"
                                                                                switches

                                                                            />
                                                                        </div>
                                                                        <button type="button" @click="setcolumn()" class="btn btn-primary d-none">Save</button>
                                                                    </b-form-group>
                                                                </b-dropdown-form>
                                                            </b-dropdown>
                                                        </div>
                                                        {{clickSelect}}
                                                        <!-- alpha fix- removed class ml-2  -->
                                                        <div class="d-inline-block report-selected-columns" v-if="column_selected_view.length > 0"> <span class="font-semi-bold text-secondary py-1 px-2 bg-white rounded" v-for="column in column_selected_view">{{ stringView(column) }}</span></div>
                                                    </div>
                                                <!-- <div class="d-inline-block ml-3 pt-2">{{show_selected}} {{clickSelect}}</div> -->
                                                </div>
                                                <div class="ibox col-md-12">
                                                    <div class="ibox-content px-0 pt-3">
                                                        <table class="table 108_return">
                                                            <thead>
                                                                <tr class="table-head">
                                                                    <th scope="col">Type of Return</th>
                                                                    <th scope="col">Fiscal Year</th>
                                                                    <th scope="col">View Details</th>
                                                                    <th scope="col">Download Excel</th>
                                                                    <th scope="col">Upload Receipt</th>
                                                                    <th scope="col">Download Receipt</th>
                                                                    <th scope="col">Submission Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr style="display: none;"></tr>
                                                                <tr class="table-row hover-bg" v-for="(data, n) in received_report_info" :key="n">
                                                                    <td>108 Return</td>
                                                                    <td>{{data.fiscal_year}}</td>
                                                                    <td><a href="#" @click="viewDetails(data.fiscal_year , '')" v-if="$acl['regulatory/filing/view/details'] == 2">View Details</a></td>
                                                                    <td><a @click="getReport(data.fiscal_year, '', '', '')" class="cursor-pointer" v-if="$acl['regulatory/filing/download'] == 2"><img v-bind:src="$api_url+'/images/excel-icon.png'" class="mr-2" width="20px"/>Download</a></td>
                                                                    <td><a href="#" @click="showUpload(data.fiscal_year , '')" v-if="$acl['regulatory/filing/upload'] == 2"><b-icon icon="upload" class="mr-2"></b-icon>Upload</a></td>
                                                                    <td><a v-if="data.received_copy_108 == 'yes' && $acl['regulatory/filing/download'] == 2" :href="$api_url+'/payroll_report_return108?received_report=received_download&year='+data.fiscal_year+'&dataflg=1'"><b-icon icon="download" class="mr-2"></b-icon>Download</a><a v-else>N/A</a></td>
                                                                    <td>{{data.file_date_108 || compliance_placeholder}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <lock-template ></lock-template>
                                        </template>
                                    </b-tab>
                                    <b-tab lazy @click="handleChange(1)"> <!-- Mustafijur: 13-05-2026 -->
                                        <template #title>
                                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                <img v-bind:src="$api_url+'/images/return-108a-new.png'" class="light-mode-icon"/>
                                                <h5>Return u/s 108A</h5>
                                                <p>Get your annual tax return filing statement that is required to be filed by 30 April of each year under Section 108A of the Income Tax Ordinance 1984.</p>
                                                <b-button class="btn btn-primary">View Report</b-button>
                                            </div>
                                        </template>
                                        <div>
                                        <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                            <div class="row mt-4 no-margin">
                                                <div class="ibox col-md-12">
                                                    <div class="ibox-title dashboard_title px-0">
                                                        <h4 class="font-regular with-blue-text">Current Selected: <span>Return u/s 108A</span></h4>
                                                    </div>
                                                    <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                                                        <div class="d-inline-block trz_fields trz-custom-dropdown" >
                                                            <b-dropdown id="dropdown-fields"  text="Select Additional Fields" ref="dropdown" class="mb-1 position-relative">
                                                                <b-dropdown-form>
                                                                    <b-form-group @submit.stop.prevent>
                                                                        <div class="form-group">
                                                                            <b-form-checkbox-group
                                                                                v-model="column_selected"
                                                                                :options="column_options"
                                                                                switches

                                                                            />
                                                                        </div>
                                                                        <button type="button" @click="setcolumn()" class="btn btn-primary d-none">Save</button>
                                                                    </b-form-group>
                                                                </b-dropdown-form>
                                                            </b-dropdown>
                                                        </div>
                                                        {{clickSelect}}
                                                          <!-- alpha fix- removed class ml-2  -->
                                                        <div class="d-inline-block report-selected-columns" v-if="column_selected_view.length > 0"> <span class="font-semi-bold text-secondary py-1 px-2 bg-white rounded" v-for="column in column_selected_view">{{ stringView(column) }}</span></div>
                                                    </div>
                                                </div>
                                                <!-- <div class="d-inline-block ml-3 pt-2">{{show_selected}} {{clickSelect}}</div> -->
                                            </div>
                                            <div class="ibox col-md-12">
                                                    <div class="ibox-content px-0 pt-3">
                                                    <table class="table 108A_return ">
                                                        <thead>
                                                            <tr class="table-head">
                                                            <th scope="col">Type of Return</th>
                                                            <th scope="col">Fiscal Year</th>
                                                            <th scope="col">View Details</th>
                                                            <th scope="col">Download Excel</th>
                                                            <th scope="col">Upload Receipt</th>
                                                            <th scope="col">Download Receipt</th>
                                                            <th scope="col">Submission Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr style="display: none;"></tr>
                                                            <tr class="table-row hover-bg" v-for="(data, n) in received_report_info" :key="n">
                                                                <td>108A Return</td>
                                                                <td>{{data.fiscal_year}}</td>
                                                                <td><a href="#" @click="viewDetails(data.fiscal_year , 'A')" v-if="$acl['regulatory/filing/view/details'] == 2">View Details</a></td>
                                                                <td><a @click="getReport(data.fiscal_year, 'A', '', '')" class="cursor-pointer" v-if="$acl['regulatory/filing/download'] == 2"><img v-bind:src="$api_url+'/images/excel-icon.png'" class="mr-2" width="20px"/>Download</a></td>
                                                                <td><a href="#" @click="showUpload(data.fiscal_year , 'A')" v-if="$acl['regulatory/filing/upload'] == 2"><b-icon icon="upload" class="mr-2"></b-icon>Upload</a></td>
                                                                <td><a v-if="data.received_copy_108a == 'yes' && $acl['regulatory/filing/download'] == 2" :href="$api_url+'/payroll_report_return108a?received_report=received_download&year='+data.fiscal_year+'&dataflg=1'"><b-icon icon="download" class="mr-2"></b-icon>Download</a><a v-else>N/A</a></td>
                                                                <td>{{data.file_date_108a || compliance_placeholder}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <lock-template ></lock-template>
                                        </template>
                                        </div>
                                    </b-tab>
                                    <b-tab lazy @click="handleChange(2)"> <!-- Mustafijur: 13-05-2026 -->
                                        <template #title>
                                            <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                <img v-bind:src="$api_url+'/images/Monthly_Tax_Computation_Sheet_2_.png'" class="light-mode-icon"/>
                                                <h5>Monthly statement of tax deducted at source</h5>
                                                <p>Get your monthly salary statement that is required to be filed by 20th of each month under Section 50, Rule 21 of the Income Tax Ordinance 1984.</p>
                                                <b-button class="btn btn-primary">View Report</b-button>
                                            </div>
                                        </template>
                                        <div>
                                            <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                                <statement-of-deduct-data  :key="tabKey"></statement-of-deduct-data>
                                            </template>
                                            <template v-else>
                                                <lock-template ></lock-template>
                                            </template>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </template>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </div>

        <b-modal id="view-details" dialog-class="modal-xxl" size="xl" scrollable  hide-footer title="Details">
            <b-overlay  rounded="sm">
                <!-- alpha fix- removed border-bottom  -->
                <div class="clearfix row py-2 mb-2 ">
                    <div class="col-sm-6 px-3 company-form-box-title">{{fiscal_year}}</div>
                </div>

                <table class="table ">
                    <thead class="" style="">
                        <tr class="table-head"  v-for="(detail, index) in paginatedData" :key="detail.employee_ID">
                            <template v-if="index < 1">
                                <td class="text-center" v-for="(v,i,count) in detail"><template v-if="i == 'employee_etin'">e-TIN</template><template v-else>{{ replaceTableHeads(i) }}</template></td>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg " v-for="detail in paginatedData" :key="detail.employee_ID">
                            <!--aboni 10-11-21-->
                                <template v-for="(v,i,count) in detail">
                                    <td v-if="column_selected.indexOf(stringViewReverse(i)) !== -1 || column_selected.indexOf(i) !== -1">{{v}}</td>
                                    <td v-else-if="i == 'Name Of Employee' || i == 'Job Position' || i == 'details'">{{v}}</td>
                                    <td v-else class="text-right">{{v}}</td>

                                </template>
                                <!--aboni 10-11-21-->
                        </tr>
                    </tbody>
                </table>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{empty_result}}</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages"  prev-text="Previous" next-text="Next"  base-url="#" first-number last-number ></b-pagination-nav></div>
            </b-overlay>
        </b-modal>

        <b-modal id="view-details-a" dialog-class="modal-xxl" size="xl" scrollable  hide-footer title="Details">
            <b-overlay  rounded="sm">
                <!-- alpha fix- removed border-bottom  -->
                <div class="clearfix row py-2 mb-2 ">
                    <div class="col-sm-6 px-3 company-form-box-title">{{fiscal_year}}</div>
                </div>

                <table class="table ">
                    <thead class="" style="">
                        <tr class="table-head"  v-for="(detail, index) in paginatedData" :key="detail.employee_ID">
                            <template v-if="index < 1">
                                <td class="text-center" v-for="(v,i,count) in detail"><template v-if="i == 'employee_etin'">e-TIN</template><template v-else>{{ replaceTableHeads(i) }}</template></td>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg " v-for="detail in paginatedData" :key="detail.employee_ID">
                            <!--aboni 10-11-21-->
                                <template v-for="(v,i,count) in detail">
                                    <td v-if="column_selected.indexOf(stringViewReverse(i)) !== -1 || column_selected.indexOf(i) !== -1">{{v}}</td>
                                   <td v-else-if="i == 'Name Of Employee' || i == 'Job Position' || i == 'details' || i == 'SL._No.'">{{v}}</td>
                                    <td v-else class="text-right">{{v}}</td>

                                </template>
                                <!--aboni 10-11-21-->
                        </tr>
                    </tbody>
                </table>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{empty_result}}</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"  first-number last-number ></b-pagination-nav></div>
            </b-overlay>
        </b-modal>

        <b-modal id="upload-excell" size="lg" centered  hide-footer title="Upload Receipt File">
            <b-form @submit.stop.prevent="uploadFile">
                <b-form-group id="datafile-group" label="File" class="half-width mr1" label-for="datafile">
                    <b-form-file id="datafile" name="datafile" accept=".xlsx,.xls" v-on:change="handleFileUpload()" aria-describedby="datafile-feedback" data-vv-as="File"></b-form-file>
                    <b-form-invalid-feedback id="datafile-feedback">{{ veeErrors.first('datafile') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group id="file-date-group" label="Date [YYYY-MM-DD] *" class="half-width" label-for="day_one_text">
                    <b-input-group class="my-0">
                        <b-form-input id="file_date_text" v-model="file_date_text" name="file_date_text" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('file_date_text')" aria-describedby="file_date_text-feedback" data-vv-as="From Date"></b-form-input>
                        <b-input-group-append>
                            <b-form-datepicker id="file_date" v-model="file_date_text" @context="onContext" aria-controls="file_date_text" button-only right locale="en-US"></b-form-datepicker>
                        </b-input-group-append>
                        <b-form-invalid-feedback id="file_date_text-feedback">{{ veeErrors.first('file_date_text') }}</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
                <div class="full-width text-center mt-5">
                    <b-button type="submit" variant="primary">Submit</b-button>
                </div>
            </b-form>
        </b-modal>



    </div>
</template>
<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
            // this.getAcl();
        },
        props: [ 'flag'],
        components: {

        },
        data(){

            return {

                cu:window.location.href,
                ce:false,


                showoverlay : true,

                details : [],
                excelfile : null,
                file_date_text: '',
                selected: '',

                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},

                empty_result : 'Fetching data..',

                fiscal_year : '',
                upload_url : '',
                tabIndexRF: 0,
                compliance_placeholder: 'N/A',

                received_report_info : [],
                tab_one_error : false,
                loader: false,
                /***Ali */

                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                show_selected:'',
                tabKey: 0,

                tabIndexRFParent: 0,

            }
        },
        methods:{
            open_item_selected: function(item)
            {
                this.tabIndexRFParent = item;
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            viewDetails: function(year , l)
            {
                if(!this.checkNet()) return false;

                if(this.column_selected.indexOf('name') === -1){
                    this.column_selected.unshift('name');
                }

                this.details = [];
                this.fiscal_year = year;
                let url = this.$api_url;

                if(l == 'A')
                    url = url + '/return108a-data-custom';
                else
                    url = url + '/return108-data-custom';

                let currentObj = this;
                let formData = new FormData();
                formData.append('year', this.fiscal_year);
                formData.append('column_selected', this.column_selected);
                axios.post(url, formData).then(function (response)
                {
                    this.details = response.data;

                    if(this.details.length == 0)
                        this.empty_result = 'No Result Found!';

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});



                if(l == 'A')
                    this.$bvModal.show('view-details-a');
                else
                    this.$bvModal.show('view-details');


            },

            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');

                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    if(val[i].length == 2 && val[i] == 'pf'){
                        val[i] = val[i].toUpperCase();
                    }else{
                        val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                    }
                }
                return val.join(' ');
            },

            showUpload: function(year , l)
            {
                if(!this.checkNet()) return false;
                this.file_date_text = '';
                this.excelfile = null;

                this.details = [];
                this.fiscal_year = year;

                this.showoverlay = true;

                let url = this.$api_url;

                if(l == 'A')
                    url = url + '/payroll_report_return108a?upload_received_copy=upload&year='+year+'&dataflg=1';
                else
                    url = url + '/payroll_report_return108?upload_received_copy=upload&year='+year+'&dataflg=1';

                this.upload_url = url;

                this.$bvModal.show('upload-excell');
            },
            handleFileUpload(){
                this.excelfile = event.target.files[0];
            },
            onContext(ctx){
                this.file_date_text = ctx.selectedYMD;
                this.selected = ctx.selectedYMD;
            },
            handleChange(index){
                //window.location.reload();
                sessionStorage.setItem('key', index);
                this.tabKey += 1;
                // if(this.$cookies.isKey("report_column_selected"))
                // {
                //     if(this.$cookies.get("report_column_selected") != null && this.$cookies.get("report_column_selected") != '')
                //     {
                //         if(Array.isArray(this.$cookies.get("report_column_selected")))
                //         {
                //             this.column_selected = this.$cookies.get("report_column_selected");
                //         }
                //         else
                //         {
                //             this.column_selected = this.$cookies.get("report_column_selected").split(',');
                //         }
                //     }
                // }
            },
            uploadFile:function(event)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {

                        this.$bvToast.toast("Please fill all required fields [marked red]", {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        });

                        return;
                    }
                    if(this.selected == ''){
                        this.$bvToast.toast("Please insert correct date format [YYYY-MM-DD]", {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        });

                        return;
                    }
                    this.showoverlay = true;

                    //this.excelfile = event.target.files[0];

                    const config = {
                            headers: { 'content-type': 'multipart/form-data' }
                        }
                    const data = new FormData();
                    data.append('image', this.excelfile);
                    data.append('year', this.fiscal_year);
                    data.append('file_date_text', this.file_date_text);

                    axios.post(this.upload_url, data , config).
                        then(function (response){


                        this.$bvModal.hide('upload-excell');

                            this.$bvToast.toast('Uploaded successfully.', {
                                                title: `Success`,
                                                variant: 'info',
                                                solid: true
                                            });


                          this.getReceivedFile();
                        }.bind(this)).
                        catch(function (error)
                        {
                            //alert(error.response.data.errors);
                        });
                });
            },
            getReceivedFile: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/return/get_payroll_report_return108_received_copy' , {
                    params: {

                    }
                }).then(function(response){
                    this.received_report_info = response.data;
                    //console.log(this.received_report_info);

                }.bind(this));
            },
            getReport: function(year , l, act, format)
            {

                if(!this.checkNet()) return false;
                this.loader = true;

                if(this.column_selected.indexOf('jobposition') === -1){
                    this.column_selected.unshift('jobposition');
                }
                if(this.column_selected.indexOf('name') === -1){
                    this.column_selected.unshift('name');
                }
                let formData = new FormData();
                formData.append('year', year);
                if(act == 'new'){
                    formData.append('act', 'new');
                }else{
                    formData.append('act', 'old');
                }
                if(format == 'bn'){
                    formData.append('format', format);
                }else{
                    formData.append('format', 'en');
                }
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                formData.append('column_selected', this.column_selected);
                const config = {
                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }
                let url = this.$api_url;

                if(l == 'A')
                    url = url + '/payroll_report_return108a_custom';
                else
                    url = url + '/payroll_report_return108_custom';

                axios.post(url, formData, config).then(function (response)
                {
                    //this.payroll_reporting_data = response.data;
                    //console.log(response.data);
                    //var fileURL = this.$api_url+'/payroll_head_basis_yearly_report?grid_report=Excel&year='+fiscal_year;
                    // var fileURL = response.data;
                    // this.download_file(fileURL);
                    this.loader = false;
                    if(response.data.type =='application/json'){
                        let file = new Blob([response.data], {type: 'application/json'});
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                        });
                    }else{
                        this.global_download_file_content(response);
                    }

                }.bind(this))
                .catch(error => {
                    if(error.response){
                        this.loader = false;
                    }
                });
                return false;

            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            getPayrollDefaultField()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting/defaultfields' , {
                }).then(function(response){
                    this.default_fields = response.data;
                    let co = [];
					let available_colunms = [];
                    this.default_fields.forEach(element => {

                        co = co.concat([{ text: this.stringView(element) , value: element }]);
						available_colunms = available_colunms.concat(element);
                    });

                    this.column_options = this.column_options.concat(co);
                    this.column_selected.forEach(element => {
                        if(available_colunms.includes(element))
                        {
                            //
                        }
                        else
                        {
                            this.column_selected.splice( this.column_selected.lastIndexOf(element), 1);
                        }
                    });

                }.bind(this));
            },
            stringView(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';
                if(str == 'etin')                 // ADD THIS
                    return 'e-TIN';
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            stringViewReverse(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';

                str = str.replace(/ /g,"_").toLowerCase();

                return str;
            },
            setcolumn: function()
            {
                this.$cookies.set("report_column_selected", this.column_selected);
                this.$refs.dropdown.hide(true);
                this.$refs.dropdown1.hide(true);
            },
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            },

        },
        created: function(){

            // if(this.$cookies.isKey("report_column_selected"))
            // {
            //     if(this.$cookies.get("column_selected") != null && this.$cookies.get("column_selected") != '')
            //         this.column_selected = this.$cookies.get("report_column_selected").split(',');
            // }
            this.getPayrollDefaultField();
            this.fiscal_year = this.getCurrentFinancialYear();
            this.getReceivedFile();
            this.tabIndexRF = sessionStorage.getItem('key');
            //this.viewDetails();
            //Fire.$on('reloadUsers', () => {this.viewDetails()});
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.details;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            clickSelect()
            {

                this.column_selected_view = this.column_selected;
                if(this.column_selected_view.length !=  this.column_selected_view.length)
                {
                    this.column_selected_view = this.column_selected;
                }
                if(this.column_selected.indexOf('name') > -1){
                    this.column_selected.splice('name', 1);
                }
                this.show_selected = this.column_selected_view.join();
                this.show_selected = this.show_selected.replaceAll("_", " ");
                this.show_selected = this.show_selected.replaceAll(",", " , ");
                this.show_selected = this.capitalizeTheFirstLetterOfEachWord(this.show_selected);
                if(this.column_selected.length ==0)
                {
                    this.show_selected = 'None Selected';
                }

                this.$cookies.set("report_column_selected", this.column_selected);

            },
        }
    }
</script>

<style>
.lock-icon-trz-tab {
	top: 11px;
}
</style>
